export default __webpack_public_path__ + "static/media/personality-refresh.9873000a.svg";